import DashboardActionTypes from './DashboardActionTypes'

export interface SetSelectedDate {
  type: DashboardActionTypes.SET_SELECTED_DATE;
  payload: {
    date:   Date;
  }
}

export function setSelectedDate({
 date,
}: SetSelectedDate['payload']): SetSelectedDate {

  return {
    type: DashboardActionTypes.SET_SELECTED_DATE,
    payload: {
      date,
    },
  }
}
